import style from "./About3.module.css";
import about3title from "../../assets/images/about3title.png";
import about3title2 from "../../assets/images/about3title2.png";
import slideimg1 from "../../assets/images/honor/1.jpg";
import slideimg2 from "../../assets/images/honor/2.jpg";
import slideimg3 from "../../assets/images/honor/3.jpg";
import slideimg4 from "../../assets/images/honor/4.jpg";
import slideimg5 from "../../assets/images/honor/5.jpg";
import swiperLeftButton from "../../assets/images/swiper-left-button2.png";
import swiperRightButton from "../../assets/images/swiper-right-button2.png";
import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import SwiperCore, { Pagination, Navigation, EffectCoverflow } from "swiper";
import request from "../../common/request";
// Import Swiper styles
//import 'swiper/css';

import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";
import "swiper/modules/navigation/navigation.min.css";

SwiperCore.use([EffectCoverflow, Pagination]);

export default function Main() {
  const [list1, setList1] = useState([]);
  const [list2, setList2] = useState([]);

  useEffect(() => {
    request.getColumnList("荣誉").then((result) => {
      if (result.data.data.data && result.data.data.data.length > 0) {
        var data = result.data.data.data;
        // data.push(result.data.data.data[0]);
        // data.push(result.data.data.data[0]);
        // data.push(result.data.data.data[0]);
        setList1(data);
      }
      console.log("list1", data);
    });

    request.getColumnList("资质").then((result) => {
      if (result.data.data.data && result.data.data.data.length > 0) {
        var data = result.data.data.data;
        setList2(data);
      }
      console.log("list2", data);
    });
  }, []);

  return (
    <>
      <div className={style.about3box}>
        <img src={about3title} />
        <div className={style.sec2}>
          {list2.map((item, index) => (
            <div>
              <img src={item.pic} />
            </div>
          ))}
        </div>

        <img src={about3title2} />
        <div className={style.slidediv}>
          <div className={style.swiperc}>
            <Swiper
              className={style.swiper}
              //slidesPerView={1}
              effect={"coverflow"}
              grabCursor={true}
              centeredSlides={true}
              slidesPerView={"auto"}
              coverflowEffect={{
                rotate: 30,
                stretch: 50,
                depth: 80,
                modifier: 1,
                slideShadows: true,
              }}
              navigation={{
                nextEl: ".swiper-button-next1",
                prevEl: ".swiper-button-prev1",
                disabledClass: "disable", // 当导航按钮变为不可用时添加的class
              }}
              loop={true}
              onSlideChange={() => console.log("slide change")}
              onSwiper={(swiper) => console.log(swiper)}
            >
              {list1.length > 0 &&
                list1.map((item, index) => (
                  <SwiperSlide className={style.slide} key={index}>
                    <img src={item.pic} />
                  </SwiperSlide>
                ))}
              {list1.length == 0 && (
                <SwiperSlide className={style.slide}>
                  <img src={slideimg1} />
                </SwiperSlide>
              )}
            </Swiper>
            <div
              className="swiper-button1 swiper-button-prev1"
              style={{ top: "-170px" }}
            >
              <img src={swiperLeftButton} />
            </div>
            <div
              className="swiper-button1 swiper-button-next1"
              style={{ top: "-170px" }}
            >
              <img src={swiperRightButton} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
